import useConceptConfiguration from '../ConceptCalculation/useConceptConfiguration'
import General from './General'
import AreaOverview from './AreaOverview'
import Modules from './Modules'
import FloorAnalysis from './FloorAnalysis/FloorAnalysis'
import { ProductionDistance } from '../../../../../types/OrganizationUnit'
import { Concept } from '../../../../../types/Survey/Analysis/Concept'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import Diagrams from './Diagrams/Diagrams'

type Props = {
  productionDistance: ProductionDistance
}

export const isUnitAllowedByProductionDistance = (concept: Concept, unitUUID: string, productionDistance: ProductionDistance) => {
  if (productionDistance) {
    return concept.units[unitUUID]?.productionDistance === productionDistance
  }
  return true
}

const SummaryProductionDistance: React.FC<Props> = ({ productionDistance }) => {
  const { getActiveConcept, conceptDataCluster } = useConceptConfiguration()
  const t = useSelector((s) => s[props.TRANSLATION])

  if (!getActiveConcept() && !!conceptDataCluster) return null
  const concept = getActiveConcept()

  const hasUnits =
    Object.keys(concept.units)
      .filter((u) => u !== 'sum')
      .filter((u) => isUnitAllowedByProductionDistance(concept, u, productionDistance)).length > 0

  return (
    <div className="flex flex-col gap-3">
      {hasUnits ? (
        <>
          <Diagrams concept={concept} productionDistance={productionDistance} />
          <General concept={concept} conceptDataCluster={conceptDataCluster} productionDistance={productionDistance} />
          <FloorAnalysis concept={concept} productionDistance={productionDistance} />
          <AreaOverview concept={concept} productionDistance={productionDistance} />
          <Modules concept={concept} productionDistance={productionDistance} />
        </>
      ) : (
        <div className="text-gray-500 text-sm">{t.survey.analysis.calculation.values.productionDistance.noUnits}</div>
      )}
    </div>
  )
}

export default SummaryProductionDistance
